import gsap from 'gsap';
import { html } from '@resn/gozer-core';
import { unsafeHTML } from 'lit-html/directives/unsafe-html';
import { autobind } from 'core-decorators';
import { Component, componentMixin } from '@resn/gozer-core/component';
import DomComponentMixin from '@resn/gozer-core-mixins/dom-component';
import { COLORS } from 'core/constants';

import Layers from './layers';

import './index.scss';

const template = ({ props, options }) => html` <div class="transitionOverlay"></div> `;

@componentMixin(DomComponentMixin)
class TransitionOverlay extends Component {
    options = {
        template,
    };

    props = {
        active: false,
        bgColor: COLORS.DARK_BLUE,
    };

    async onSetup() {
        window.overlay = this;

        this.layers = await new Layers().setup({
            options: {
                appendTo: this.el,
            },
            props: {
                bgColor: () => this.props.bgColor,
            },
        });
    }

    show(options) {
        return new Promise((resolve) => {
            this.layers.show(options, resolve);

            this.el.style.opacity = 1;

            // const xFrom = `${100 * dir}%`;

            // gsap.set(this.el, { x: xFrom });
            // gsap.to(this.el, {
            //     x: 0,
            //     duration: 0.5,
            //     ease: 'sine.in',
            //     onComplete: resolve,
            // });
        });
    }

    hide(options) {
        return new Promise((resolve) => {
            this.layers.hide(options, () => {
                this.el.style.opacity = 0;

                resolve();
            });
            // const xTo = `${100 * -dir}%`;

            // gsap.to(this.el, {
            //     x: xTo,
            //     duration: 2,
            //     ease: 'expo.out',
            //     onComplete: resolve,
            // });
        });
    }
}

export default TransitionOverlay;
